import { testResultSchema } from '../testResultSchema'

// 分類定数・フォーム表示用スキーマのみここに置く。OCR専用のプロンプト・OCR出力スキーマは
// @mbscan/backend-ocr（packages/backend/ocr/src/categories/document/schemas/nouhinsho.ts）が正本。

// 納入書（納入伝票）。プラントが生コンを運搬するトラック1台につき1枚発行する伝票で、
// 様式はプラントごとに異なるため、帳票名にメーカー名を含めない汎用名で扱う。
// 顧客ニーズは「打設ロット毎の帳票一式に納入書PDFを含めたい」であり、伝票の中身の
// データ化は求められていない。そのため抽出は打設日・打設箇所（納入場所）のみに留め、
// ロット（TestResult）へのグルーピングに必要な最小限の情報だけをデータ化する。
export const nouhinshoDocumentNameText = '納入書'
export const nouhinshoDocumentType = '納入書'

export const nouhinshoFormFieldsSchema = testResultSchema.pick({
  打設日: true,
  打設箇所: true,
})
